import Title from '../../components/Title';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../Layout';
import useLoggedIn from '../../hooks/useLoggedIn';
import TabPane from '@components/TabPane';
import AddMediaResource from '../../components/resource/AddMediaResource';
import AddTextResource from '@components/resource/AddTextResource';

const AddResources = () => {
  useLoggedIn();
  const { state } = useLocation();
  const { groupId } = state;
  const navigate = useNavigate();

  const tabs = ['Media', 'Text & Links'];

  const handleBack = () => {
    // Write the desired tab index before going back so GroupInfo can read it
    sessionStorage.setItem('groupInfoActiveTab', '1');
    navigate(-1);
  };

  return (
    <Layout onBack={handleBack}>
      <Title onBack={handleBack}>Add Resources</Title>
      <TabPane tabs={tabs} centered>
        <AddMediaResource groupId={groupId} onSuccess={handleBack} />
        <AddTextResource groupId={groupId} onSuccess={handleBack} />
      </TabPane>
    </Layout>
  );
};

export default AddResources;
